import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";

const AddressLine = (props) => {
  let { required, label, name, maxLengths } = props;

  if (required === undefined) {
    required = false;
  }
  if (maxLengths === undefined) {
    maxLengths = 50;
  }
  const isAddress = (name) => {
    //Latin-1 without Appendix E
    const re = /^[ "&-.0-:A-Za-z:0-9]{1,50}$/;
    return name && re.test(name)
      ? undefined
      : name === undefined || name?.length === 0
        ? "Please enter a valid address"
        : "Please enter a valid address";
  };

  return (
    <Field
      name={name}
      validate={isAddress}
      label={label}
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: maxLengths }}
    />
  );
};

export default AddressLine;

